import axiosClient from "../../../../axiosClient"

export default async (id, fields) => {
    const result = await axiosClient.get(`/pre-check-secure-fields/${id}`, {
        params: { fields: fields.join(",") },
    })
    return result.data
}
